import React from 'react';

import { useTranslation } from 'react-i18next';
import { Progress } from '@bringg/react-components';

import useTimeFormat from 'bringg-web/hooks/use-time-format';
import useDateTimeFormat from 'bringg-web/hooks/use-date-time-format';
import useDateFormat from 'bringg-web/hooks/use-date-format';
import { optimizationTimeProps } from '../types';

import './in-progress-step.scss';

const ERROR_COLOR = '#ff3333';
export interface InProgressStepProps {
	progressPercent: number;
	tasksCountInTimeRange: number;
	optimizationTime: optimizationTimeProps;
	selectedResourcesCount: number;
	isMultiDayOptimization: boolean;
	showInfo?: boolean;
	barStatus?: 'success' | 'normal' | 'exception' | 'active';
}

const InProgressStep: React.FC<InProgressStepProps> = ({
	progressPercent,
	tasksCountInTimeRange,
	selectedResourcesCount,
	optimizationTime,
	isMultiDayOptimization,
	showInfo = true,
	barStatus
}: InProgressStepProps): JSX.Element => {
	const { t } = useTranslation();
	const timeFormat = useTimeFormat();
	const dateFormat = useDateFormat();
	const dateTimeFormat = useDateTimeFormat();

	const multiDayOptimizationTimeFrame = () => {
		return (
			<div>
				{`${(optimizationTime as optimizationTimeProps).startTime?.format(dateTimeFormat)} - ${(
					optimizationTime as optimizationTimeProps
				).endTime?.format(dateTimeFormat)}`}
			</div>
		);
	};

	const singleDayOptimizationTimeFrame = () => {
		return (
			<div>
				{`${(optimizationTime as optimizationTimeProps).startTime?.format(dateFormat)} ${(
					optimizationTime as optimizationTimeProps
				).startTime?.format(timeFormat)} - ${(optimizationTime as optimizationTimeProps).endTime?.format(
					timeFormat
				)}`}
			</div>
		);
	};

	const getBarColor = () => {
		return barStatus === 'exception' ? ERROR_COLOR : undefined;
	};
	return (
		<div className="in-progress-step">
			<div data-test-id="optimization-details" className="optimization-details">
				<div className="optimization-count-details">
					<div>{t('OPTIMIZATION_MODAL.OPTIMIZE')}</div>
					<div className="bold-text">
						{t('RESOURCES_TABLE.ORDERS_COUNT', { count: tasksCountInTimeRange })}
					</div>
					<div>{t('OPTIMIZATION_MODAL.BETWEEN')}</div>
					<div className="bold-text">
						{t('RESOURCES_TABLE.RESOURCES_COUNT', { count: selectedResourcesCount })}
					</div>
				</div>
				<div data-test-id="optimization-time">
					{isMultiDayOptimization ? multiDayOptimizationTimeFrame() : singleDayOptimizationTimeFrame()}
				</div>
			</div>
			<Progress
				percent={progressPercent}
				width={60}
				className="progress-bar"
				showInfo={showInfo}
				status={barStatus}
				trailColor={getBarColor()}
				strokeColor={getBarColor()}
			/>
		</div>
	);
};

export default InProgressStep;
